import { loadLocaleMessages } from "@/shared/config/i18n/vue-i18n";

const SUPPORTED_LANGS = ["pt", "es", "en"];
const DEFAULT_LANG = "pt";

/**
 * Obtém o idioma a ser usado na aplicação e carrega as traduções.
 * Prioridade:
 * 1. Idioma salvo no localStorage.
 * 2. Idioma do sistema operacional (navegador).
 * 3. Idioma padrão ('pt') como fallback.
 * @returns {Promise<string>} O código do idioma que será usado ('pt', 'es', ou 'en').
 */
export async function getDefaultLanguage(): Promise<string> {
  let chosenLang = localStorage.getItem("lang");

  if (chosenLang && SUPPORTED_LANGS.includes(chosenLang)) {
    await loadLocaleMessages(chosenLang);
    return chosenLang;
  }

  const browserLang = navigator.language.split("-")[0].toLowerCase();

  if (SUPPORTED_LANGS.includes(browserLang)) {
    chosenLang = browserLang;
  } else {
    chosenLang = DEFAULT_LANG;
  }

  await loadLocaleMessages(chosenLang);

  return chosenLang;
}
